
<ngx-smart-modal #myModal1 identifier="myModal1">
  <h2 class="modalError">Please login and subscribe to access this content.</h2>
  <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
</ngx-smart-modal>
<ngx-smart-modal #myModal2 identifier="myModal2">
  <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
  <button class="modalErrorButton" (click)="myModal2.close(); refreshNow()" >Refresh Now</button>
</ngx-smart-modal>
<div class="loadingBox" *ngIf="!loaded">
  <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
 </div><div class="single-video">
    <script src="https://player.dacast.com/js/player.js?contentId=1552_f_297509" id="1552_f_297509" width="800" height="500" class="dacast-video"></script>

                <div id="videoholder"></div>
                <div id="scriptholder"></div>
                </div>
                <div class="col-md-8">
                  <div class="video-desc mb-3">
                    <h2>
                      <a class="videoTitle">{{video.title}}</a>
                    </h2>
                    <p>{{video.description}}</p>
                    <a *ngIf="menuShow" class="buttonback" (click)="showMenu()"> <i class="fas fa-fw fa-times"></i></a>
                    <a *ngIf="!menuShow" class="buttonback" (click)="showMenu()"> <i class="fas fa-fw fa-ellipsis-h"></i></a>
                    <a class="favButtonMenu" style="cursor: pointer;" *ngIf="menuShow && !Isfavourite == true" (click)="favourite(video.id, video.playlistID )" title="Add to Favourites"><i class="fas fa-fw fa-heart"></i></a>
                    <a class="favButtonMenu" style="cursor: pointer;" *ngIf="menuShow && Isfavourite == true" (click)="unfavourite(video.id, video.playlistID )" data-toggle="modal" data-target="#removefromfav" title="UnFavourite"><i class="far fa-fw fa-heart"></i></a>
                    <a class="laterButtonMenu" style="cursor: pointer;" *ngIf="menuShow && !IswatchLater == true" (click)="watchLater(video.id, video.playlistID )"  title="Watch Later" ><i class="fas fa-fw fa-clock"></i></a>
                    <a class="laterButtonMenu" style="cursor: pointer;" *ngIf="menuShow && IswatchLater == true" (click)="unwatchLater(video.id, video.playlistID )"  title="Remove from Watch Later" ><i class="far fa-fw fa-clock"></i></a>
                    <a *ngIf="menuShow" class="backButtonMenu" routerLink="/playlist/{{video.channelID}}/{{video.playlistID}}/videos"> <i class="fas fa-fw fa-arrow-left"></i></a>
                
                  </div>
                  </div>
                  <div *ngIf="isWoohoo && totalEntries > 0" class="col-md-8">
                      <div class="video-desc mb-3">
                                  <div id="text">Your Daily Entries: <span class="pulsate">{{totalEntries}}</span></div>
                                  <div class="row">
                                      <img class="howtoWinDesk" style="width: 100%;" src='assets/img/howtowin.png' />
                                      <img class="howtoWinMobile" style="width: 100%;" src='assets/img/howtowinmobile.png' />
                             
                                 </div>
                                </div>
                  </div>
                 
              <!-- Watch More -->
              <div class="col-md-12">
                <app-all-content ></app-all-content>
                  <div style="min-height: 150px;"></div>
                  <!-- <div class="video-desc mb-3">
                      <h3>
                        <a i18n="@@Watch More | Watch More Title" routerLink="#">Watch More</a>
                      </h3>
                    </div>
              <div class="play-more mb-4">
                  <div *ngFor="let video of contents | slice:0:8; let i=index;" class="video-card-list col-md-4">
                      <div class="video-card-image" [class.educationImages]="isHeadStart">
                        <a class="play-icon" routerLink="/play/{{video.id}}">
                          <i class="fas fa-play-circle"></i>
                        </a>
                        <a routerLink="/play/{{video.id}}">
                          <img class="img-fluid" src={{video.contentImageUrl}} alt="">
                        </a>
                      
                      </div>
                      <div class="video-card-body">
                        <div class="video-title">
                          <a routerLink="/play/{{video.currentContentView}}">{{video.title}}</a>
                        </div>
                        <!-- <div class="video-view">
                          1.8M views &nbsp;
                          <i class="fas fa-calendar-alt"></i> 11 Months ago
                        </div>
                        </div>

              </div>
            </div> -->
          </div>
          

<div class="container">
   
    <!-- add to favourites -->
    <div class="modal fade" id="addtofav" role="dialog">
      <div class="modal-dialog">
      
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 i18n="@@Added to Favourites | Added to Favourites Popup Text" class="modal-title">Added to Favourites</h4><a class="viewlist" data-dismiss="modal"><i _ngcontent-c3="" class="fas fa-fw fa-window-close"></i></a>
          </div>
          <div class="modal-body">
              <h3><a data-dismiss="modal" i18n="@@View your list | View your list text in pop up"class="viewlist" routerLink="/my-list">View your List Here</a></h3>
          </div>
        </div>
        
      </div>
    </div>
       <!-- add to watch later -->
       <div class="modal fade" id="watchlater" role="dialog">
          <div class="modal-dialog">
          
            <!-- Modal content-->
            <!-- <div class="modal-content">
              <div class="modal-header">
                <h4 i18n="@@Added to watch later | Added to watch later text in pop up box" class="modal-title">Added to Watch Later</h4><a class="viewlist" data-dismiss="modal"><i _ngcontent-c3="" class="fas fa-fw fa-window-close"></i></a>
              </div>
              <div class="modal-body">
                  <h3><a data-dismiss="modal" i18n="@@View your List | View your list here link" class="viewlist" routerLink="/my-list">View your List Here</a></h3>
                </div>
            </div> -->
            
          </div>
        </div>
    
  </div>
            <!-- <div class="navbarbottom">
              <a routerLink="/channel/{{channelID}}/explore" i18n="@@Back to Channel link"><i _ngcontent-c3="" class="fas fa-fw fa-arrow-left"></i>TO CHANNEL</a>
              <a style="cursor: pointer;" *ngIf="!Isfavourite == true" (click)="favourite(video.id, video.playlistID )" title="Add to Favourites"><i class="fav-heart fas fa-heart"></i></a>
              <a style="cursor: pointer;" *ngIf="Isfavourite == true" (click)="unfavourite(video.id, video.playlistID )" data-toggle="modal" data-target="#removefromfav" title="UnFavourite"><i class="fav-heart far fa-heart"></i></a>
              <a style="cursor: pointer;" routerLink="/my-list" title="View my list" i18n="@@View my List Link"><i class="fas fa-list"></i> VIEW MY LIST</a>
              <a style="cursor: pointer;" *ngIf="!IswatchLater == true" (click)="watchLater(video.id, video.playlistID )"  title="Watch Later" i18n="@@Add to watch Later"><i class="fas fa-clock"></i> + WATCH LATER</a>
              <a style="cursor: pointer;" *ngIf="IswatchLater == true" (click)="unwatchLater(video.id, video.playlistID )"  title="Watch Later" i18n="@@Remove from watch Later"><i class="fas fa-clock"></i> REMOVE FROM WATCH LATER</a>
            </div> -->
            <span *ngFor="let message of celebrationMessages let i=index; last as final">
              <span *ngIf="final && message.type == 'CELEBRATION' && confettiGunReady && !message.notificationNoted"> 
                    <div >
                            <div id="text"></div>
                            <span *ngIf="confettiGunLoaded">
                                    {{confettiGun()}}
                                    {{clearNotification([message.id])}}
                                    {{clearNotifications()}}
                                   
                            </span>
                            
                          </div>
            </span>
            </span>